module.exports = __webpack_public_path__ + "static/img/08003C_1_R_20200812_LC.d9be9d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/08003C_1_R_20200812_LC.png
// module id = cdV4
// module chunks = 0